import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ENVIRONMENT, NoopNgZone } from '@recruitee/common';
import { PHRASE_APP_TRANSLATIONS } from '@recruitee/i18n';
import { ThemeService } from '@recruitee/user-interface';

import { RtoAppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.prodMode) {
  enableProdMode();
}

const bootstrap = async () => {
  ThemeService.setThemeHTMLData();
  const ngModule: NgModuleRef<any> = await platformBrowserDynamic([
    {
      provide: PHRASE_APP_TRANSLATIONS,
      useValue: [{ en: {} }],
    },
    { provide: ENVIRONMENT, useValue: environment },
  ]).bootstrapModule(RtoAppModule, {
    ngZone: new NoopNgZone(),
  });

  return ngModule;
};

bootstrap();
